import { Component, Input } from '@angular/core';

@Component({
    selector: 'dms-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
    @Input('loading') loading = false;
    constructor() { }
}
